
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { Toast } from 'vant'

export default {
components: {
Swiper,
Divider,
Alert
},
data () {
return {
swiperIndex: 0,
collectFlag:false,
image:[],
model:{
goodsId : this.$route.query.goodsId
},
list:"",
status: this.$route.query.status,
show:false,
message:"",
}
},
created(){
window.location.href="/m/mall/hardware/detail.html?goodsId="+this.model.goodsId;




















},
methods: {
addHistory(){
this.$http.post(this.global.httpUrl + '/rest/v1/goods/footmark/addGoodsFootMark',{'goodsId':this.model.goodsId,'type':3},{emulateJSON:true}).then(function(res){
if(res.body.success)
{
console.log('足迹更新成功');
}else{
console.log('足迹更新失败：'+res.body.message);
}
},function(res){
console.log(res.status);
});
},
addCollection(){
var self=this;
this.$http.post(this.global.httpUrl + '/rest/v1/goods/collection/addGoodsCollection',{'goodsId':this.model.goodsId,'type':3},{emulateJSON:true}).then(function(res){
if(res.body.success)
{
Toast('收藏成功');
self.collectFlag=true;
}else{
Toast('收藏失败：'+res.body.message);
}
},function(res){
console.log(res.status);
});
},
isCollect(){
var self=this;
this.$http.post(this.global.httpUrl + '/rest/v1/goods/collection/isCollect',{'goodsId':this.model.goodsId,'type':3},{emulateJSON:true}).then(function(res){
self.collectFlag=res.body.success
console.log(self.collectFlag)
},function(res){
console.log(res.status);
});
},
goBack(){




window.history.go(-1);
},
ShowColler(){
this.show=true
this.message="手机端暂不支持此功能。请移步至PC端操作"
},
swiperChange (index) {
this.swiperIndex = index
},
addClick(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mhardware/addGoodsClick',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{

}
},function(res){
console.log(res.status);
});
}
}
}



// WEBPACK FOOTER //
// ./src/views/mall/hardware/detail.vue